/* eslint-disable react/prop-types */
import CardPartnerComponent from "./card-partner";
import { useHistory } from "react-router-dom";
function CardPartner({ item }) {
  const history = useHistory();

  const { imageSamll, name, description } = item;
  const handleClick = () => {
    history.push(`/partner/${name}`);
  };

  return (
    <CardPartnerComponent
      image={imageSamll}
      onClick={handleClick}
      title={name}
      description={description}
    />
  );
}

export default CardPartner;
